module.exports = __webpack_public_path__ + "static/media/icon-nozzle.cd5901ac.svg";